import { Controller } from "stimulus";

// Slide-in editor drawer for ticket statuses (same pattern as the ticket detail
// drawer). Opens when the status_editor turbo-frame starts loading the new/edit
// form (the frame's fetch event bubbles up here), and closes on backdrop / X /
// Escape, or automatically after a successful save (turbo:submit-end success).
export default class extends Controller {
  static targets = ["panel", "backdrop"];
  static values = { frame: String };

  connect() {
    const frame = document.getElementById(this.frameValue);
    this.placeholder = frame ? frame.innerHTML : "";

    this.boundOpen = this.open.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);
    this.boundSubmitEnd = this.onSubmitEnd.bind(this);
    this.element.addEventListener("turbo:before-fetch-request", this.boundOpen);
    this.element.addEventListener("turbo:submit-end", this.boundSubmitEnd);
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.boundOpen);
    this.element.removeEventListener("turbo:submit-end", this.boundSubmitEnd);
    document.removeEventListener("keydown", this.boundKeydown);
    document.body.classList.remove("overflow-hidden");
  }

  open() {
    this.panelTarget.classList.remove("translate-x-full");
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none");
    document.body.classList.add("overflow-hidden");
    document.addEventListener("keydown", this.boundKeydown);
  }

  close(event) {
    if (event) event.preventDefault();
    this.panelTarget.classList.add("translate-x-full");
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none");
    document.body.classList.remove("overflow-hidden");
    document.removeEventListener("keydown", this.boundKeydown);

    const frame = document.getElementById(this.frameValue);
    if (frame) frame.innerHTML = this.placeholder;
  }

  // A failed save returns 422 (success=false) and re-renders the form in place —
  // keep the drawer open. A successful save returns turbo streams (success=true).
  onSubmitEnd(event) {
    if (event.detail && event.detail.success) this.close();
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close();
  }
}
